import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';
import { PolicyModel , PolicyDetailModel , ClaimModel } from '../Model/PolicyModel.js'
import dayjs from 'dayjs'; //https://day.js.org/

/**
 * @method apiGetCampaign
 * @method apiRemoveFavourite
 */
export default {

    apiGetPolicy: function () {
        const token = Account.getToken();

        let params = {
            device_app_id: ConfigManager.getAppId(),
            bzbTime: dayjs().unix()
        }

        const url = ConfigManager.getApiModuleUrl() + "/tni/policies";

        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                // console.log(res.data)
                let arrPolicy = [];
                for (let i of res.data) {
                    let objPolicy = new PolicyModel(i);
                    arrPolicy.push(objPolicy);
                }

                return arrPolicy;
            }));
    },

    apiGetPolicyDetail: function (policyNo) {
        const token = Account.getToken();

        let params = {
            device_app_id: ConfigManager.getAppId(),
            bzbTime: dayjs().unix()
        }

        const url = ConfigManager.getApiModuleUrl() + "/tni/" + policyNo + "/policy";

        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                // console.log(res.data)
                let policyDetail = new PolicyDetailModel(res.data)
                return policyDetail;
            }));
    },

    apiGetClaim: function (policyNo) {
        const token = Account.getToken();

        let params = {
            device_app_id: ConfigManager.getAppId(),
            bzbTime: dayjs().unix()
        }

        const url = ConfigManager.getApiModuleUrl() + "/tni/" + policyNo + "/claim";

        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                // console.log(res.data)
                let arrClaim = [];
                for (let i of res.data) {
                    let objClaim = new ClaimModel(i);
                    arrClaim.push(objClaim);
                }
                return arrClaim;
            }));
    },
}
